import http from "./http";

export const GetRates = async () => {
    return await http.get("/rates");
};

export const GetRate = async id => {
    return await http.get("/rates/" + id);
};
